// ProtectedRoute.js
import { Outlet, Navigate } from 'react-router-dom'
import { checkTokenValidity } from '../utils/jwtValidity';


const AdminPrivateRoute = ({token, requiredRole }) => {
      const isValidToken = checkTokenValidity(token);
      //console.log(isValidToken,'bla')
  

      // Check if the user has the required rol
       if (requiredRole && requiredRole !== "Admin" && !isValidToken) {
         return <Navigate to="/" />;
       }
    
      // If authenticated and has the required role, render the component
      return <Outlet/>;
    };
    

export default AdminPrivateRoute